module.exports = " <div class=\"row text-center\"> <h2>¡Se ha cancelado tu pedido!</h2> <br/> <p class=text-center> Por cualquier consulta que tengas puedes consultarnos por correo a cuentas@lasddi.com o telefónicamente al (33) 2748 2493.<br><br> </p> <a v-link=\"{ path: '/carrito-de-compra' }\"><button type=button class=\"btn btn-black\" style=\"margin-left: 15px\">Regresar al carrito</button></a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shopping-cart/Shopping-cart-canceled.vue
// module id = 559
// module chunks = 0